import { render, staticRenderFns } from "./payProjectData.vue?vue&type=template&id=2fbc3986&scoped=true&"
import script from "./payProjectData.vue?vue&type=script&lang=js&"
export * from "./payProjectData.vue?vue&type=script&lang=js&"
import style0 from "./payProjectData.vue?vue&type=style&index=0&id=2fbc3986&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc3986",
  null
  
)

export default component.exports